import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ControllerPage, NotificationPage, SettingsPage } from './pages';

const SettingFeature: React.FC = () => {
  return (
    <Routes>
      <Route index element={<SettingsPage />} />
      <Route path="controller" element={<ControllerPage />} />
      <Route path="notification" element={<NotificationPage />} />
    </Routes>
  );
};

export default SettingFeature;